import heading from "@/components/renderers/heading";
import paragraph from "@/components/renderers/paragraph";
import squareImage from "@/components/renderers/square-image";
import alert from "@/components/renderers/alert";
import bucket from "@/components/renderers/bucket";
import container from "@/components/renderers/container";
import flexContainer from "@/components/renderers/flex-container";
import card from "@/components/renderers/card";
import keyVisual from "@/components/renderers/key-visual";
import navbar from "@/components/renderers/navbar";
import anchor from "@/components/renderers/anchor";
import receiptProcessor from "@/components/renderers/receipt-processor"
import productUpload from "@/components/renderers/product-upload"
import formComponent from "@/components/renderers/form-component"
import textInput from "@/components/renderers/text-input"
import stepCard from "@/components/renderers/step-card"
import stepsComponent from "@/components/renderers/steps-component"
import selectInput from "@/components/renderers/select-input"
import radioInput from "@/components/renderers/radio-input"
import dateInput from "@/components/renderers/date-input"
import buttonComponent from "@/components/renderers/button-component"
import emptyBucket from "@/components/renderers/empty-bucket"
import receiptInformation from "@/components/renderers/receipt-information"
import checkbox from "@/components/renderers/checkbox"
import gtinComponent from "@/components/renderers/gtin-component"
import stepCounter from "@/components/renderers/step-counter"
import landingSteps from "@/components/renderers/landing-steps"
import footerComponent from "@/components/renderers/footer-component"
import question from "@/components/renderers/question"
import textList from "@/components/renderers/text-list"
import reclaimBucket from "@/components/renderers/reclaim-bucket"
import injectTag from "@/components/renderers/inject-tag"
import dataLayerEvent from "@/components/renderers/datalayer-event"
import refreshToken from "@/components/renderers/refresh-token"
import segmentaCookieHandler from "@/components/renderers/segmenta-cookieHandler"
import background from "@/components/renderers/background"
import selectedProductShow from "@/components/renderers/selected-product-show"
import checkBoxTerms from "@/components/renderers/checkbox-terms"
import doi from "@/components/renderers/doi"
import urlToken from "@/components/renderers/urlToken"
import urlParser from "@/components/renderers/url-parser"
import survey from "@/components/renderers/survey"
import conditions from "@/components/renderers/conditions"
import faq from "@/components/renderers/faq"
import queryStringToState from "@/components/renderers/query-string-to-state"
import ibanReupload from "@/components/renderers/iban-reupload"
import countdownTimer from "@/components/renderers/countdown-timer"
import languageDropdown from "@/components/renderers/language-dropdown"
import newForm from "@/components/renderers/new-form"
import videoComp from "@/components/renderers/video-comp"

export default [
  checkBoxTerms,
  segmentaCookieHandler,
  refreshToken,
  dataLayerEvent,
  injectTag,
  reclaimBucket,
  textList,
  question,
  stepCounter,
  landingSteps,
  receiptInformation,
  heading,
  paragraph,
  squareImage,
  alert,
  bucket,
  emptyBucket,
  container,
  flexContainer,
  card,
  keyVisual,
  navbar,
  anchor,
  receiptProcessor,
  productUpload,
  formComponent,
  textInput,
  stepCard,
  stepsComponent,
  selectInput,
  radioInput,
  dateInput,
  buttonComponent,
  checkbox,
  gtinComponent,
  footerComponent,
  background,
  selectedProductShow,
  doi,
  urlToken,
  urlParser,
  survey,
  conditions,
  faq,
  queryStringToState,
  ibanReupload,
  countdownTimer,
  languageDropdown,
  newForm,
  videoComp
];
